<template>
  <div class="navbar bg-base-100 shadow-sm">
    <div class="flex-1">
      <a
        class="btn btn-ghost press-start-2p-regular text-primary text-xl font-bold"
      >
        <img src="/logo.png" alt="Logo" class="h-9 w-auto" />
      </a>
      <ul class="menu menu-horizontal px-1">
        <li>
          <router-link
            class="font-bold"
            :class="$route.path.startsWith('/campaign') && 'menu-active'"
            to="/campaign"
          >
            <i class="fa-solid fa-users-gear"></i>
            Chiến dịch
          </router-link>
        </li>
        <li>
          <router-link
            class="font-bold"
            :class="$route.path.startsWith('/version') && 'menu-active'"
            to="/version"
          >
            <i class="fa-solid fa-code-branch"></i>
            Phiên bản
          </router-link>
        </li>
        <li v-if="auth_store.isAdmin">
          <router-link
            class="font-bold"
            :class="$route.path.startsWith('/user') && 'menu-active'"
            to="/user"
          >
            <i class="fa-solid fa-user"></i>
            Người dùng
          </router-link>
        </li>
        <li>
          <router-link
            class="font-bold"
            :class="$route.path.startsWith('/client') && 'menu-active'"
            to="/client"
          >
            <i class="fa-solid fa-desktop"></i>
            Tất cả máy trạm
          </router-link>
        </li>
        <li>
          <router-link
            class="font-bold"
            :class="$route.path.startsWith('/files') && 'menu-active'"
            to="/files"
          >
            <i class="fa-solid fa-folder-open"></i>
            Tệp tin
          </router-link>
        </li>
      </ul>
    </div>
    <div class="flex-none">
      <div class="mr-2 flex items-center gap-2">
        <div class="text-right">
          <div class="text-sm font-semibold">{{ auth_store.user }}</div>
          <div class="text-xs capitalize opacity-60">{{ auth_store.role }}</div>
        </div>
        <div class="dropdown dropdown-end">
          <div
            tabindex="0"
            role="button"
            class="btn btn-ghost btn-circle avatar"
          >
            <div class="w-10 rounded-full shadow">
              <img
                :alt="auth_store.user"
                :src="`https://api.dicebear.com/9.x/identicon/svg?seed=${encodeURIComponent(auth_store.avatarSeed || auth_store.user)}&backgroundType=solid&backgroundColor=dfe3f5&rowColor=3d4272`"
              />
            </div>
          </div>
          <ul
            tabindex="-1"
            class="menu menu-md dropdown-content bg-base-100 rounded-box z-1 mt-3 w-52 p-2 shadow"
          >
            <li>
              <a @click="logout_and_dismiss">
                <i class="fa-solid fa-right-from-bracket"></i>
                Đăng xuất
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { use_auth } from "@/auth/useAuth";
import { toast } from "vue3-toastify";

const auth_store = use_auth();

const logout_and_dismiss = () => {
  auth_store
    .logout()
    .then(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    })
    .catch((err) => {
      toast.error(err);
    });
};
</script>
